import React, { useCallback, useMemo } from 'react';

import { ViewStyle } from 'react-native';

import { useTranslation } from 'react-i18next';

import EpgGridView from 'assets/images/svgs/ico_epg_grid_view.svg';
import EpgGridViewSelected from 'assets/images/svgs/ico_epg_grid_view_selected.svg';
import EpgListView from 'assets/images/svgs/ico_epg_list_view.svg';
import EpgListViewSelected from 'assets/images/svgs/ico_epg_list_view_selected.svg';

import { EpgLayout } from 'store/epg/reducer.types';

import SvgButton from 'components/CustomButtons/SvgButton';

type Props = {
    type: EpgLayout;
    onButtonPress: (type: EpgLayout) => void;
    selected: boolean;
    accessibilityLabel: string;
    style?: ViewStyle;
};

const ICON_SIZE = {
    width: 32,
    height: 32,
};

const EpgLayoutButton = ({
    type,
    onButtonPress,
    selected,
    style,
    accessibilityLabel,
}: Props) => {
    const { t } = useTranslation();

    const GridIcon = useMemo(() => {
        return selected ? EpgGridViewSelected : EpgGridView;
    }, [selected]);

    const ListIcon = useMemo(() => {
        return selected ? EpgListViewSelected : EpgListView;
    }, [selected]);

    const handlePress = useCallback(() => {
        onButtonPress(type);
    }, [type, onButtonPress]);

    return (
        <SvgButton
            accessible
            accessibilityLabel={t(accessibilityLabel)}
            style={style}
            Svg={type === EpgLayout.GRID ? GridIcon : ListIcon}
            svgStyle={ICON_SIZE}
            onPress={handlePress}
            accessibilityRole="button"
        />
    );
};

export default EpgLayoutButton;
